import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ToolbarGroupComponent } from './toolbar-group.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ToolbarGroupComponent],
  exports: [ToolbarGroupComponent],
})
export class ToolbarGroupModule {}
export { ToolbarGroupComponent } from './toolbar-group.component';
